import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, hasPermissions, loading } = useAuth();
    const location = useLocation();


    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '50vh',
                    gap: 2
                }}
            >
                <CircularProgress size={60} />
                <Typography variant="h6" color="text.secondary">
                    Loading...
                </Typography>
            </Box>
        );
    }

    if (!isAuthenticated) {
        // Store the intended destination in the login redirect
        const redirectPath = location.pathname + location.search;
        const encodedRedirect = encodeURIComponent(redirectPath);
        return <Navigate to={`/login?redirect=${encodedRedirect}`} replace />;
    }

    // Check if user has permissions (only if authenticated)
    if (isAuthenticated && !hasPermissions) {
        return <Navigate to="/permission-denied" replace />;
    }

    return children;
};

export default ProtectedRoute;
